import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Junta classes do Tailwind resolvendo conflito (`px-2 px-4` vira `px-4`). */
export function cn(...entradas: ClassValue[]): string {
  return twMerge(clsx(entradas));
}
